import RedesignLayout from "@/chrome/RedesignLayout";
import type { NextPageWithLayout } from "@/pages/_app";
import BlogPostPage from "@/components/Blog/BlogPostPage";
import { body } from "@content/blog/posts/why-rust-its-the-safe-choice";

const Page: NextPageWithLayout = () => (
  <BlogPostPage slug="why-rust-its-the-safe-choice" body={body} />
);

Page.getLayout = (page) => (
  <RedesignLayout showAnnouncement={false}>{page}</RedesignLayout>
);

export default Page;
